<template>
    <gateway-demo-frame
        demo_route_name=""
        hero_icon="mdi-account-check"
        hero_title="Guest Check-In Experience Demo"
        hero_subtitle="Curious what a Guest Check-In experience looks like? Try out these demo experiences to see how RedChirp can help you gather guest information and consent seamlessly."
    >
        <div class="card-grid">
            <v-card
                v-for="experience in experiences"
                :key="experience.to.params.guest_check_in_form_id"
                class="experience-card"
                elevation="3"
            >
                <v-card-title class="pb-0 text-h6">
                    {{ experience.title }}
                </v-card-title>

                <v-card-text>
                    <p class="text-left mb-8">{{ experience.description }}</p>

                    <div class="qr-code-container text-center mb-4">
                        <div class="qr-code">
                            <v-icon
                                v-if="!experience.qr_code_id"
                                large
                            >mdi-qrcode</v-icon>
                            <qr-code
                                v-else
                                :qr_code_id="experience.qr_code_id"
                            />
                        </div>
                        <div class="caption mt-2">Scan to experience on mobile</div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        type="button"
                        target="_blank"
                        :to="experience.to"
                    >
                        Try Experience
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </gateway-demo-frame>
</template>

<script>
import GatewayDemoFrame from '@/components/demos/shared/gateway-frame.vue';
import QrCode from "@/components/demos/guest-checkin/qr-code.vue";

export default {
    name: 'GuestCheckInDemoIntro',

    components: {
        GatewayDemoFrame,
        QrCode,
    },

    data() {
        return {
            // links off to RedChirp demo GCI forms in prod
            experiences: [
                {
                    qr_code_id: null,
                    title: 'Default Check In',
                    description: 'Our proposed default guest check-in experience with streamlined consent gathering.',
                    to: {
                        name: 'guest-check-in-public-app',
                        params: {
                            guest_check_in_form_id: 'e7e4474b-dd4c-44c1-bd2c-b08a1504ba75'
                        }
                    }
                },
                {
                    qr_code_id: null,
                    title: 'Conservative Check In',
                    description: 'A conservative approach with explicit checkbox consent for each communication channel.',
                    to: {
                        name: 'guest-check-in-public-app',
                        params: {
                            guest_check_in_form_id: '81da4c14-965e-4de1-9119-78e71de8235a'
                        }
                    }
                },
                {
                    qr_code_id: null,
                    title: 'Discount Check In',
                    description: 'A discount-themed experience that incentivizes opt-in with a 10% off offer upon check-in.',
                    to: {
                        name: 'guest-check-in-public-app',
                        params: {
                            guest_check_in_form_id: '6ad40a13-b4b2-4c90-9e7e-01205e4dbc9f'
                        }
                    }
                }
            ]
        };
    },

    async mounted() {
        document.title = "Guest Check-In Demo | RedChirp";

        for (const experience of this.experiences) {
            if (!experience.qr_code_id) {
                await new Promise(resolve => {
                    this.$rc.rest({
                        spinner: true,
                        endpoint: 'PUT: /api/v1/guest-check-in/forms/generate-qr-code',
                        params: { ...experience.to.params },
                        on_success: (data) => {
                            this.$set(experience, 'qr_code_id', data.qr_code_id);
                            resolve();
                        },
                        on_error: () => {
                            resolve();
                        }
                    });
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
    margin-top: 1rem;
    margin-bottom: 3rem;

    .experience-card {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        padding-bottom: 1.2rem;
        border-top: 3px solid var(--v-primary-base);
    }
    
    .qr-code-container {
        .qr-code {
            width: 12rem;
            height: 12rem;
            border: 2px dashed #ccc;
            border-radius: 0.5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
        }
    }
    
    :deep(.v-card__actions) {
        padding: 0 1rem;
    }
}
</style>